import React, { useEffect, useRef } from "react";
import approved from "../images/approved.png";
import rejected from "../images/rejected.png";
import comment from "../images/comment.png";
import approval_pending from "../images/approval_pending.png";
import videoPlay from "../images/videoPlay.png";
import TeacherCommentBox from "./TeacherCommentBox";

const TeacherVideoCard = ({
  video,
  openModal,
  isModalOpen,
  closeModal,
  removeVideo,
  handleVideoClick,
}) => {
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);

  useEffect(() => {
    function checkOverflow(element) {
      return (
        element.scrollWidth > element.clientWidth ||
        element.scrollHeight > element.clientHeight
      );
    }

    if (titleRef.current && checkOverflow(titleRef.current)) {
      titleRef.current.classList.add("show-tooltip");
    } else {
      titleRef.current.classList.remove("show-tooltip");
    }

    if (descriptionRef.current && checkOverflow(descriptionRef.current)) {
      descriptionRef.current.classList.add("show-tooltip");
    } else {
      descriptionRef.current.classList.remove("show-tooltip");
    }
  }, [video.title, video.description]);

  return (
    <div className={`teacher_video-card ${video.videostatus.toLowerCase()}`}>
      <div className="teacher_video_thumbnail" style={{ cursor: "pointer" }}>
        <img
          src={video.thumbnail.url}
          alt="Thumbnail"
          onClick={() => handleVideoClick(video)}
        />
      </div>
      <div className="teacher_video_details">
        <div className="teacher_video_title_play">
          <div className="teacher_video_title" ref={titleRef}>
            {video.title}
          </div>
          <div className="teacher_video_title_tooltip">{video.title}</div>
          <div
            className="teacher_video_play"
            onClick={() => handleVideoClick(video)}
            style={{ cursor: "pointer" }}
          >
            <img src={videoPlay} alt="play" />
          </div>
        </div>
        <div className="teacher_video-time">{video.time}</div>
        <div className="teacher_video-tags">
          {video.tags.map((tag, index) => (
            <div key={index} className="teacher_tag">
              {tag}
            </div>
          ))}
        </div>
        <div className="teacher_video-description" ref={descriptionRef}>
          <p>{video.description}</p>
        </div>
        <div className="teacher_video-description-tooltip">
          {video.description}
        </div>
      </div>

      <div className="teacher_videos_status_buttons">
        {(video.videostatus === "Pending" ||
          video.videostatus === "pending") && (
          <div className="teacher_status-label">
            <div className="teacher_status-label_img">
              <img src={approval_pending} alt="approval pending" />
            </div>
            <div className="teacher_status-label-text">Approval Pending</div>
          </div>
        )}

        {(video.videostatus === "Approved" ||
          video.videostatus === "approved") && (
          <div className="teacher_status-label">
            <div className="teacher_status-label_img">
              <img src={approved} alt="approved" />
            </div>
            <div className="teacher_status-label-text">Approved</div>
          </div>
        )}

        {(video.videostatus === "Rejected" ||
          video.videostatus === "rejected") && (
          <div className="teacher_status-label">
            <div className="teacher_status-label_img">
              <img src={rejected} alt="reject" />
            </div>
            <div className="teacher_status-label-text">Rejected</div>
            <img
              src={comment}
              alt="comment"
              onClick={() => openModal(video)}
              style={{ cursor: "pointer" }}
            />
          </div>
        )}
      </div>

      {isModalOpen && (
        <TeacherCommentBox
          comments={video.remarks}
          isOpen={isModalOpen}
          onClose={closeModal}
          onRemoveVideo={removeVideo}
        />
      )}
    </div>
  );
};

export default TeacherVideoCard;
